// Store token in local store or session store.
import { jwtDecode } from "jwt-decode";

export const setToken = (value, remember) => {
  if (remember) localStorage.setItem('token', value)
  else sessionStorage.setItem('token', value)
}

// Get token from local store or session store.
export const getToken = () => {
  const localToken = localStorage.getItem('token');
  const sessionToken = sessionStorage.getItem('token');
  const token = localToken || sessionToken;

  if (token !== null) {
    if (isTokenExpired(token)) {
      deleteToken();
      return null;
    }
    return token;
  }
  else return null;
}

// Delete token from local store or session store.
export const deleteToken = () => {
  if (sessionStorage.getItem('token') !== null) sessionStorage.removeItem('token');
  else if (localStorage.getItem('token') !== null) localStorage.removeItem('token');
}

// Function to check if token is expiring soon
export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    if (!decoded?.exp) return true;
    return Date.now() >= decoded.exp * 1000;
  } catch {
    return true;
  }
};
